<template>
  <apexchart
    :type="chartOptions.type"
    :options="chartOptions.chartOptions"
    :series="chartOptions.series"
  />
</template>

<script>
export default {
  props: {
    textTitle: String,
    textValue: String,
  },
  data() {
    return {
      chartOptions: {
        type: "radialBar",
        series: [55],
        chartOptions: {
          chart: {
            type: "radialBar",
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 225,
              hollow: {
                margin: 0,
                size: "70%",
                background: "#fff",
                image: undefined,
                imageOffsetX: 0,
                imageOffsetY: 0,
                position: "front",
              },
              track: {
                background: "#f1f1f1",
                strokeWidth: "67%",
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 6,
                  left: 0,
                  blur: 5,
                  opacity: 0.1,
                },
              },

              dataLabels: {
                show: true,
                name: {
                  offsetY: -10,
                  show: true,
                  color: "#7d97ff",
                  fontSize: "14px",
                },
                value: {
                  formatter: function (val) {
                    return `${val}%`;
                  },
                  color: "#7d97ff",
                  fontSize: "18px",
                  show: true,
                },
              },
            },
          },
          fill: {
            type: "gradient",
            colors: ["#7d97ff"],
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#e833fd"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: ["Destacadas"],
        },
      },
    };
  },
};
</script>